import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { DetailWithIcon } from './DetailWithIcon'

/** "Asset" (equipment) detail on the hero card (v1). */
export const EquipmentDetail = ({
  equipment,
}: {
  equipment: { name?: string | null } | null | undefined
}) => {
  const { _ } = useLingui()
  if (!equipment) return null
  return (
    <DetailWithIcon
      imgSrc='/assets/equipment.svg'
      imgAlt={_(msg`Equipment`)}
      header={_(msg`Asset`)}
      body={equipment.name}
    />
  )
}
